import React, { useEffect, useState } from "react";
import "./brand-management.scss";
import { useSearchParams } from "react-router-dom";
import { SearchBar } from "components/form";
import useDebounce from "common/UseDebounce";
import useFullPageLoader from "common/UseFullPageLoader";
import { brandListApi } from "services/brand-management";
// import { Pagination } from "react-bootstrap";
import findSerialNumber from "utils/findSerialNumber";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import NotFound from "common/NotFound";
import AddBrand from "./AddBrand";
import EditBrand from "./EditBrand";
import Pagination from "react-js-pagination";
import DeleteBrand from "./DeleteBrand";
import { CustomModal } from "components/modals/ModalBox";
import { userPlaceholder } from "assets/icons";
import { Select } from "common/InputForm";



const BrandManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();

  // delete

  const [selectedBrandDetail, setSelectedBrandDetail] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);

  // ------------search related properties
  const search = searchParams.get("search") || "";
  const userStatus = searchParams.get("status") || "";
  const debouncedValue = useDebounce(search, 300);
  const setSearchFun = (searchTxt) => {
    const newParams = new URLSearchParams(searchParams); // safe copy
    newParams.set("page", 1);
    newParams.set("search", searchTxt);

    setSearchParams(newParams);
  };
  // -------------end of search related properties

  // --------list api data related states
  const [fetchedBrandData, setFetchedBrandData] = useState([]);
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const total = +searchParams.get("total") || 1;

  const [addBrandState, setAddBrandState] = useState(false);
  const [editBrandState, setEditBrandState] = useState(false);

  const [brandIdState, setBrandIdState] = useState("");

  //*********Handel Pagination********* */

  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };

  // ------close add model
  const closeModel = () => {
    setAddBrandState(false);
    setEditBrandState(false);

    setSelectedBrandDetail({});
    setDeleteModal(false);
  };

  const brandMgmtApiCall = async () => {
    try {
      onShow();

      const query = {
        page: activePage,
        limit: limit,
        sortByName: userStatus,
      };

      if (search && debouncedValue) {
        query.search = debouncedValue;
      }

      const {
        data: {
          data: { total, brands },
        },
        status,
        code,
        message,
      } = await brandListApi(query);

      if (status || code === 200) {
        setFetchedBrandData(brands);
        const newParams = new URLSearchParams(searchParams);

        newParams.set("total", total);
        setSearchParams(newParams);
        console.log("message:--->", message);
      }
    } catch (error) {
      console.log("Cat Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    brandMgmtApiCall();
  }, [activePage, limit, debouncedValue, userStatus]);

  // -------------show image model

  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");

  // show image preview handler
  const showImagePreviewHandler = (profile) => {
    setShowImagePreviewModel(true);
    setImagePreview(profile);
  };

  return (
    <div className="brand-management-parent-container">
      {/* -brand management add Brand */}
      <div className="page_title">
        <h3>Brand Management</h3>
      </div>
      {/* -search wrapper */}
      <div className="search_wrapper">
        <div className="search-and-status-container">
          <SearchBar
            placeholder={"Search..."}
            onKeyDown={(e) => {
              const allowedKeysRegex = /^[a-zA-Z0-9\- ]$/;
              const controlKeys = [
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
                "Escape",
              ];

              // Allow letters, numbers, space, hyphen
              if (allowedKeysRegex.test(e.key) || controlKeys.includes(e.key)) {
                return;
              }

              // Block everything else
              e.preventDefault();
            }}
            onChange={(e) => setSearchFun(e.target.value)}
            value={search}
          />

          {/* -----select state */}
          <Select
            className="select-status-option"
            value={userStatus}
            onChange={(e) => {
              const urlInstance = new URLSearchParams(searchParams);
              urlInstance.set("status", e.target.value);
              urlInstance.set("page", 1);
              setSearchParams(urlInstance);
            }}
          >
            <option value="">Sort By Name</option>
            <option value="asc">A to Z</option>
            <option value="desc">Z to A</option>
            {/* <option value="DELETED">Deleted</option> */}
          </Select>
        </div>

        <button
          type="button"
          className="button"
          onClick={() => {
            setAddBrandState(true);
            // const newParams = new URLSearchParams(searchParams);
            // newParams.set("isAddBrandEnable", true);
            // setSearchParams(newParams);
          }}
        >
          Add Brand
        </button>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">Logo</th>
                <th className="nowrap text-center">Brand Name</th>
                <th className="nowrap text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {fetchedBrandData && fetchedBrandData.length ? (
                fetchedBrandData?.map((mapProp, index) => {
                  return (
                    <tr key={index} onClick={() => {
                              setBrandIdState(mapProp?._id);
                              setEditBrandState(true);
                            }}>
                      <td className="nowrap text-center">
                        {findSerialNumber(index, activePage, limit)}
                      </td>

                      <td className="nowrap text-center">
                        {/* <img
                          src={mapProp?.image!= "" ? mapProp?.image : userPlaceholder}
                          alt={mapProp?.name}
                          className="td-img"
                          onClick={(e) =>
                            
                            showImagePreviewHandler(mapProp?.image)

                            
                          }
                        /> */}


                        


                        <img
  src={mapProp?.image !== "" ? mapProp?.image : userPlaceholder}
  alt={mapProp?.name}
  className="td-img"
  onClick={(e) => {
    e.stopPropagation(); // stop row click
    showImagePreviewHandler(mapProp?.image);
  }}
/>
                      </td>
                      <td className="nowrap text-center">{mapProp?.name}</td>
                      <td className="nowrap text-center">
                        <div className="button-container">
                          <button
                            type="button"
                            onClick={() => {
                              setBrandIdState(mapProp?._id);
                              setEditBrandState(true);
                            }}
                          >
                            <FaEdit />
                          </button>

                          {/* ----delete Button */}

                          <button
                            type="button"
                            onClick={(e) => {
                              setSelectedBrandDetail(mapProp);
                              setDeleteModal(true);
                                                          e.stopPropagation(); // ⭐ add this

                            }}
                          >
                            <FaRegTrashAlt />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NotFound
                  cols={7}
                  msg={"Brand data not found"}
                  onHide={onHide}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ------image preview */}
      {showImagePreviewModel && (
        <CustomModal
          className={"sm image_preview_modal"}
          show={showImagePreviewModel}
          handleClose={() => {
            setImagePreview("");
            setShowImagePreviewModel(false);
          }}
        >
          <div className="image_preview">
            <img
              src={imagePreview || userPlaceholder}
              alt="user-profile-preview"
            />
          </div>
        </CustomModal>
      )}

      {addBrandState && (
        <AddBrand
          showAddBrand={addBrandState}
          brandMgmtApiCall={brandMgmtApiCall}
          closeModel={closeModel}
        />
      )}

      {/* -----------delete */}
      {/* Delete BANNER Modal */}
      {deleteModal && (
        <DeleteBrand
          deleteModal={deleteModal}
          selectedBrandDetail={selectedBrandDetail}
          setFetchedBrandData={setFetchedBrandData}
          closeModel={closeModel}
        />
      )}

      {editBrandState && (
        <EditBrand
          editBrandState={editBrandState}
          brandMgmtApiCall={brandMgmtApiCall}
          closeModel={closeModel}
          brandIdState={brandIdState}
        />
      )}

      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandManagement;
